import styled from '@emotion/styled';
import { Card, CardContent, Chip, Typography } from '@mui/material';

export const KpiCardWrapper = styled(Card)(({ theme }) => ({
  borderRadius: 24,
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  height: '112px',
  position: 'relative',
}));

export const ContentBox = styled(CardContent)(({}) => ({
  padding: '24px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const DifferenceChip = styled(Chip)<{ diff: number }>(({ theme, diff }) => {
  const isPositive = diff > 0;
  return {
    fontWeight: 600,
    height: 28,
    borderRadius: 10,
    backgroundColor: isPositive ? '#D5EEDB' : '#FAE1E3',
    color: isPositive ? '#28A745' : '#DC3545',
    border: 'none',
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  };
});

export const KPINameText = styled(Typography)(({}) => ({
  fontFamily: 'Inter',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '-0.16px',
  color: 'var(--Common-Black, #1E1E1E)',
}));

export const KPIValueText = styled(Typography)(({}) => ({
  fontFamily: 'Inter',
  fontSize: '28px',
  fontWeight: 700,
  lineHeight: '32px',
  letterSpacing: '-0.56px',
  color: 'var(--Common-Black, #1E1E1E)',
}));

export const WebsiteText = styled(Typography)(({}) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: 'var(--Common-Black, #1E1E1E)',
  marginTop: '10px !important',
}));
